import React, { useState } from "react";
import ModeShell from "../components/ModeShell";
import DecisionWizard from "../components/DecisionWizard";
import DecisionBrief from "../components/DecisionBrief";
import FounderDecisionMap from "../components/FounderDecisionMap";
import { useMode } from "../lib/mode";

export default function DecisionRoom() {
  const { mode, config, resolving } = useMode();
  const [result, setResult] = useState(null);

  if (resolving) {
    return (
      <ModeShell>
        <div className="flex items-center gap-2 py-20" data-testid="resolving">
          <span className="pisa-dot" />
          <span className="pisa-dot" />
          <span className="pisa-dot" />
          <span className="ml-2 text-[#666666]">Pausing…</span>
        </div>
      </ModeShell>
    );
  }

  return (
    <ModeShell>
      {!result ? (
        <div className="space-y-14">
          {/* Hero */}
          <section className="pisa-enter max-w-4xl">
            <p className="text-xs uppercase tracking-[0.2em] text-[#666666] mb-4" data-testid="hero-eyebrow">{config.eyebrow}</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tight font-medium text-[#1A1A1A] leading-[1.05]">
              {config.headline}
            </h1>
            <p className="text-lg md:text-xl text-[#666666] mt-5 max-w-2xl leading-relaxed">{config.sub}</p>

            {/* PISA letters as a quiet brand bar */}
            <div className="mt-10 flex flex-wrap items-center gap-2">
              {["Pause", "Inspect", "Sense", "Align"].map((w, i) => (
                <span key={w} className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#666666]">
                  <span className={`h-1.5 w-1.5 rounded-full ${i === 0 ? "bg-[#2596be]" : i === 1 ? "bg-[#f4b847]" : i === 2 ? "bg-[#e93e36]" : "bg-[#1A1A1A]"}`} />
                  {w}
                  {i < 3 && <span className="mx-2 text-[#E5E5E5]">·</span>}
                </span>
              ))}
            </div>
          </section>

          {/* Wizard */}
          <section className="pisa-card p-7 md:p-12">
            <DecisionWizard onComplete={setResult} />
          </section>

          {/* Mode bottom blocks */}
          {mode === "public" && (
            <section className="grid grid-cols-1 md:grid-cols-3 gap-6 pisa-enter-stagger">
              {[
                { t: "Slow the frame", d: "Pause before action. See the decision behind the decision." },
                { t: "Inspect the system", d: "Power, pressure, and bias — surfaced so they stop steering you quietly." },
                { t: "Choose the next move", d: "Smaller and smarter. Preserve optionality. Trigger a review when reality shifts." },
              ].map((card) => (
                <div key={card.t} className="pisa-card p-7">
                  <p className="text-xs uppercase tracking-[0.2em] text-[#f4b847] mb-3">PISA</p>
                  <h3 className="text-lg font-medium text-[#1A1A1A] mb-2">{card.t}</h3>
                  <p className="text-sm text-[#666666] leading-relaxed">{card.d}</p>
                </div>
              ))}
            </section>
          )}

          {mode === "member" && (
            <section id="map">
              <FounderDecisionMap />
            </section>
          )}
        </div>
      ) : (
        <DecisionBrief
          payload={result.payload}
          brief={result.brief}
          saved={result.saved}
          onRestart={() => setResult(null)}
        />
      )}
    </ModeShell>
  );
}
